import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        getFontesMonitoradas(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/FontesMonitoradas',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        exportarRelatorioFontesMonitoradas(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ExportarRelatorioFontesMonitoradas',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getcarregarControleFontes(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ControleFontes',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        exportarRelatorioControleFonte(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ExportarRelatorioControleFonte',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getRelatorioProcessos(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/RelatorioProcessos',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        exportarRelatorioProcessos(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ExportarRelatorioProcesso',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        exportarRelatorioAlertas(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ExportarRelatorioAlertas',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getResumoAlertas(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/RelatorioAlertas',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getResumoAlertasJusBr(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/RelatorioAlertasJusBr',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        exportarRelatorioAlertasJusBr(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Relatorio/ExportarRelatorioAlertasJusBr',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getTribunais(filter) {
            return instance({
                method: 'get',
                baseURL,
                url: 'Relatorio/ListarTribunais',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
    }
    return apiCalls;
}